import { AUTH } from "../constants/authConstant";

export const resetAll = () => ({
  type: AUTH.RESET_ALL,
});
